<script setup lang="ts">
const { t } = useI18n()
const { telegramWebApp, telegramShare } = useTelegram()
const userStore = useUserStore()
const { info, isCreator } = storeToRefs(userStore)

const show = ref(false)
const isShareX = ref(false)
const isSharePostX = ref(false)
useLockAppScrollWhenVisible(show)

const close = () => {
  show.value = false
}

const queryTaskList = async () => {
  try {
    const res = await telegramService.queryTaskList()
    isShareX.value = res.find((v: { sceneCode: string }) => v.sceneCode === 'tg_share_x')?.preAccess
    isSharePostX.value = res.find(
      (v: { sceneCode: string }) => v.sceneCode === 'tg_share_post_x',
    )?.preAccess
  } catch (err) {
    console.error(err)
  }
}

// 生成创作者邀请码
const queryInviteCode = async () => {
  try {
    const data = await userService.invitationCodeGenerate()
    let url = ''
    if (data.referralLinkInvitationCode) {
      url += `ref_${data.referralLinkInvitationCode}`
    }
    if (isCreator.value) {
      // d: domain
      url += `_d_${info.value?.creatorDomain}`
    }
    const message = `${info.value?.creatorDomain ? `This is ${info.value?.creatorDomain}.` : ''} Join dfans with me today and enjoy the ultimate subscription platform for creators! \n
  A decentralized platform like OnlyFans
  - No overbearing KYC procedures
  - USDT Payout, No Limits, No High Fees
  - USDC Payout, No Limits, No High Fees
  `
    telegramShare(url, message)
    close()
  } catch (error) {
    console.error(error)
  }
}

const chooseHandle = async (flag: string) => {
  if (flag === 'follow') {
    if (!isShareX.value) return
    try {
      await telegramService.shareX()
      isShareX.value = true
      close()
      telegramWebApp.openLink('https://x.com/dfans_xyz')
    } catch (err) {
      console.error(err)
    }
  } else if (flag === 'invite') {
    queryInviteCode()
  } else if (flag === 'repost') {
    if (!isSharePostX.value) return
    await telegramService.sharePostX()
    isSharePostX.value = true
    close()
    telegramWebApp.openLink('https://x.com/dfans_xyz/status/1831563350159061461')
  }
}

const open = async () => {
  show.value = true
  queryTaskList()
}

defineExpose({
  open,
})
</script>

<template>
  <n-modal
    v-model:show="show"
    :on-after-leave="close"
    :mask-closable="false"
    transform-origin="center"
  >
    <div class="w-11/12 md:w-105 relative">
      <div class="modal-content p-4">
        <header class="flex-center relative">
          <div class="text-5.5 leading-6.5 typeface-robotoMedium">
            {{ t('Global.GetRewardsEveryDay') }}
          </div>
          <div
            i-carbon:close
            class="absolute top-0 right-0 text-brandB cursor-pointer text-6 -mr-2"
            @click="close"
          />
        </header>
        <div class="mt-1 text-center text-brandB text-sm">
          {{ t('Telegram.rewardsDesc') }}
        </div>
        <img src="@/assets/telegram/bg-box.webp" class="bg-img" alt="dfans" />
        <div class="mt-7 relative">
          <img src="@/assets/telegram/gold.webp" class="w-full" alt="dfans" />
          <img
            src="@/assets/telegram/start1.webp"
            class="w-41 absolute top-2 left-26% star star-bright"
            alt="dfans"
          />
          <img
            src="@/assets/telegram/start2.webp"
            class="w-41 absolute top-2 left-26% star star-dim"
            alt="dfans"
          />
        </div>

        <div class="mt-7 relative z-1">
          <div
            class="bg-brandB bg-op-10 backdrop-blur-4 w-full h-18 rounded-2 px-3.5 flex items-center"
            @click="chooseHandle('follow')"
          >
            <img src="@/assets/telegram/X.webp" class="w-11 h-11" alt="dfans" />
            <div class="ml-3.5">
              <div class="text-base">
                {{ t('Telegram.FollowX') }}
              </div>
              <div class="text-sm font-bg w-max typeface-robotoMedium">
                + 10 {{ t('route.Shares') }}
              </div>
            </div>
            <div v-if="!isShareX" i-ph:check-bold class="ml-auto w-5 h-5 text-brandB" />
            <div v-else i-material-symbols:arrow-forward-ios-rounded class="ml-auto w-5 h-5" />
          </div>

          <div
            class="my-3 bg-brandB bg-op-10 backdrop-blur-4 w-full h-18 rounded-2 px-3.5 flex items-center"
            @click="chooseHandle('invite')"
          >
            <img src="@/assets/telegram/invite.webp" class="w-11 h-11" />
            <div class="ml-3.5">
              <div class="text-base">
                {{ t('Telegram.InviteFriends') }}
              </div>
              <div class="text-sm font-bg w-max typeface-robotoMedium">
                + 10 {{ t('route.Shares') }}
              </div>
            </div>
            <div i-material-symbols:arrow-forward-ios-rounded class="ml-auto w-5 h-5" />
          </div>

          <div
            class="bg-brandB bg-op-10 backdrop-blur-4 w-full h-18 rounded-2 px-3.5 flex items-center"
            @click="chooseHandle('repost')"
          >
            <img src="@/assets/telegram/X.webp" class="w-11 h-11" alt="dfans" />
            <div class="ml-3.5">
              <div class="text-base">
                {{ t('Telegram.RepostX') }}
              </div>
              <div class="text-sm font-bg w-max typeface-robotoMedium">
                + 10 {{ t('route.Shares') }}
              </div>
            </div>
            <div v-if="!isSharePostX" i-ph:check-bold class="ml-auto w-5 h-5 text-brandB" />
            <div v-else i-material-symbols:arrow-forward-ios-rounded class="ml-auto w-5 h-5" />
          </div>
        </div>
      </div>
    </div>
  </n-modal>
</template>

<style scoped lang="less">
.star {
  transition: opacity 0.5s ease-in-out;
}

/* 亮的星星动画 */
.star-bright {
  animation: brightStarFlicker 3s infinite;
}

/* 暗的星星动画 */
.star-dim {
  animation: dimStarFlicker 3s infinite;
}

@keyframes brightStarFlicker {
  0%,
  30% {
    opacity: 0;
  }
  35%,
  55% {
    opacity: 0.8;
  } /* 这里使用不完全的亮度 */
  60%,
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes dimStarFlicker {
  0%,
  30% {
    opacity: 1;
  }
  35%,
  55% {
    opacity: 0.5;
  } /* 这里使用不完全的暗度 */
  60%,
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.bg-img {
  position: absolute;
  top: 40px;
  left: 50%;
  margin-left: -150px;
  height: 300px;
  width: 300px;
  background: url('@/assets/telegram/bg-box.webp') no-repeat center center;
  background-size: cover;
  animation: glowAndPulse 5s infinite ease-in-out;
}
@keyframes glowAndPulse {
  0% {
    transform: scale(0.9); /* 初始大小 */
    opacity: 0.5; /* 初始亮度 */
  }
  25% {
    transform: scale(1.1); /* 稍微放大 */
    opacity: 1; /* 变亮 */
  }
  50% {
    transform: scale(0.9); /* 恢复到原大小 */
    opacity: 0.7; /* 变暗 */
  }
  75% {
    transform: scale(0.75); /* 略微缩小 */
    opacity: 0.9; /* 略微变亮 */
  }
  100% {
    transform: scale(0.9); /* 恢复到原大小 */
    opacity: 0.5; /* 回到初始亮度 */
  }
}
</style>
